import { createApp } from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import App from "@/App.vue";

/**
 * Register Font Awesome and add Core icons
 */
import {
  faSearch,
  faUser,
  faTachometerAlt,
  faAngleDown,
  faBookOpen,
  faBars,
  faColumns,
  faPlus,
  faExternalLinkAlt,
  faEdit,
  faTrash,
  faCalendarAlt,
  faFileAlt,
  faTasks,
  faExclamationTriangle,
  faChartLine,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faUpload,
  faPencilRuler,
  faCog,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faArrowDown,
  faArrowUp,
  faBug,
  faUndo,
  faTimes,
  faCut,
  faUsers,
  faUserLock,
  faCode,
  faShieldAlt,
  faGlobeEurope,
  faLaptopCode,
  faSave,
  faMinus,
  faKey,
  faCogs,
  faDesktop,
  faSpinner,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faSearch,
  faUser,
  faTachometerAlt,
  faAngleDown,
  faBookOpen,
  faBars,
  faColumns,
  faPlus,
  faExternalLinkAlt,
  faEdit,
  faTrash,
  faCalendarAlt,
  faFileAlt,
  faTasks,
  faExclamationTriangle,
  faChartLine,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faUpload,
  faPencilRuler,
  faCog,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faArrowDown,
  faArrowUp,
  faBug,
  faUndo,
  faTimes,
  faCut,
  faUsers,
  faUserLock,
  faCode,
  faShieldAlt,
  faGlobeEurope,
  faLaptopCode,
  faSave,
  faMinus,
  faKey,
  faCogs,
  faDesktop,
  faSpinner,
  faSignOutAlt
);
const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);
